<template>
	<transition name="modal">
		<div
			class="modal-mask"
			@click="$emit('close')"
		>
			<div class="modal-wrapper">
				<div
					class="modal-container"
					:style="`width: ${width}`"
					@click.stop
				>

					<div
						class="modal-header"
						:class="noHeader ? 'float-right' : 'flex justify-between'"
					>
						<slot
							v-if="!noHeader"
							name="header"
						>
							default header
						</slot>

						<rp-button
							class="bg-opacity-0"
							typoColor="black"
							hoverColor="white"
							@click="$emit('close')"
						>
							<svg
								viewBox="0 0 20 20"
								fill="currentColor"
								class="x w-5 h-5"
							>
								<path
									fill-rule="evenodd"
									d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
									clip-rule="evenodd"
								></path>
							</svg>
						</rp-button>
					</div>

					<div class="modal-body">
						<slot>
							default body
						</slot>
					</div>

					<div
						v-if="!noFooter"
						class="modal-footer"
					>
						<slot name="footer">
							default footer
							<button
								class="modal-default-button"
								@click="$emit('close')"
							>
								OK
							</button>
						</slot>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import RpButton from "./RpButton";

export default {
	name: "RpModal",
	components: { RpButton },
	props: {
		noHeader: {
			type: Boolean,
			default: false
		},
		noFooter: {
			type: Boolean,
			default: false
		},
		width: {
			type: String,
			default: "42rem"
		}
	}
};
</script>

<style>
.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.modal-container {
	margin: 0px auto;
	padding: 1rem;
	background-color: #fff;
	border-radius: 2px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
	transition: all 0.3s ease;
	font-family: Helvetica, Arial, sans-serif;
	overflow-y: auto; 
	max-height: 90vh; 
}

.modal-header h3 {
	margin-top: 0;
	color: #42b983;
}

.modal-body {
	margin: 20px 0;
}

.modal-default-button {
	float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
	opacity: 0;
}

.modal-leave-active {
	opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
	-webkit-transform: scale(1.1);
	transform: scale(1.1);
}
</style>